module.exports = __webpack_public_path__ + "static/media/CheckBox.12a36f23.svg";